import { all, call } from 'redux-saga/effects';
import { runGaClickServiceDetector } from './ga-clickservice.pdp';
import { runGaViewServiceDetector } from './ga-viewservice.pdp';

export function* runRelatedServicesGaDetectors() {
  yield all([call(runGaClickServiceDetector), call(runGaViewServiceDetector)]);
}
